import React from 'react'

export default function Step1RightContent () {
  return (
    <>
      <div className="title title--h4">Hvad er gymnasial supplering og enkeltfag?</div>
      <div className="title title--h6">Gymnasial supplering</div>
      <div className="wysiwyg">Du kan gratis blive tilmeldt gymnasial supplering, hvis du skal bruge faget for at komme ind på en videregående uddannelse.
      </div>
      <div className="title title--h6">Enkeltfag</div>
      <div className="wysiwyg">Hvis du ikke skal direkte ind på en videregående uddannelse, men skal bruge faget, skal du tilmelde dig kurset som enkeltfag og selv betale deltagergebyret.
      </div>
    </>
  )
}